import { render, staticRenderFns } from "./Fatzebra.vue?vue&type=template&id=243a25f6&"
import script from "./Fatzebra.vue?vue&type=script&lang=js&"
export * from "./Fatzebra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports